PageApp.Views.TimeLeftView = Backbone.Marionette.ItemView.extend({
  getTemplate: function () {
    return hbs.templates.timeLeft
  },
  serializeData: function () {
    return this.model.attributes
  }
})
